"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*tslint:disable*/
var containerStyle = "color:#8c8c8c;font-size:14px;text-align:center;line-height:2;font-family:'-apple-system',BlinkMacSystemFont,'SegoeUI',Roboto,'HelveticaNeue',Helvetica,'PingFangSC','HiraginoSansGB','MicrosoftYaHei',SimSun,'sans-serif';pointer-events:none;";
var nameStyle = 'font-weight:300;';
var valueStyle = 'font-size:32px;font-weight:bold;color:#4D4D4D';
function getSingleDataTemplate(value, classId, size) {
    var domStyle = containerStyle + "width:" + size + "px;";
    return "<div class=\"ring-guide-html " + classId + "\" style=" + domStyle + "><span class=\"ring-guide-value\" style=" + valueStyle + ">" + value + "</span></div>";
}
exports.getSingleDataTemplate = getSingleDataTemplate;
function getTwoDataTemplate(name, value, classId, size) {
    var domStyle = containerStyle + "width:" + size + "px;";
    return "<div class=\"ring-guide-html " + classId + "\" style=" + domStyle + "><span class=\"ring-guide-name\" style=" + nameStyle + ">" + name + "</span><br/><span class=\"ring-guide-value\" style=" + valueStyle + ">" + value + "</span></div>";
}
exports.getTwoDataTemplate = getTwoDataTemplate;
//# sourceMappingURL=statistic-template.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/ring/component/statistic-template.js
// module id = 965
// module chunks = 37